import React from 'react';
import { Link } from 'react-router-dom';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { SEO } from '../components/SEO';
import { ArrowRightIcon, SearchIcon } from 'lucide-react';
import { services } from '../data/services';
export const NotFoundPage: React.FC = () => {
  const internalServices = services.filter(service => !service.external);
  return <div className="w-full min-h-screen bg-white text-[#111827] font-sans flex flex-col" data-id="element-1890" data-mp="36sm3xjivc5j2">
      <SEO title="Deze pagina bestaat niet | Noord Digital" description="De pagina die je zocht bestaat niet of is verplaatst. Bekijk onze diensten of ga terug naar de homepage van Noord Digital." canonical="https://noorddigital.nl/" noindex data-id="element-1891" data-mp="31uu4m4fw9h4u" />
      <Header data-id="element-1892" data-mp="3bt9slyjmkaa4" />

      <main className="flex-grow" data-id="element-1893" data-mp="3bqnmm3cdu2u0">
        <section className="container mx-auto px-4 md:px-6 lg:px-8 max-w-[1200px] pt-32 pb-20 md:pt-40 md:pb-24" data-id="element-1894" data-mp="1md23uhsi11fl">
          <div className="max-w-3xl" data-id="element-1895" data-mp="1hfim37wle6iw">
            <span className="inline-flex items-center justify-center w-14 h-14 rounded-xl bg-[#EEF5FA] text-[#004AC7] mb-6" data-id="element-1896" data-mp="1hgk11ngqbd5w">
              <SearchIcon className="h-7 w-7" aria-hidden="true" data-id="element-1897" data-mp="10daydvgkjet9" />
            </span>
            <p className="text-[#6B7280] font-semibold mb-3" data-id="element-1898" data-mp="10b7vwby8bt7n">Foutcode 404</p>
            <h1 className="font-bold text-[#111827] text-4xl md:text-5xl leading-tight mb-6" data-id="element-1899" data-mp="15bchggdzve4q">
              Deze pagina bestaat niet
            </h1>
            <p className="text-[#4B5563] text-lg leading-relaxed mb-10" data-id="element-1900" data-mp="1f3029yg1pwx8">
              De link is verouderd of er staat een typefout in het adres. Via
              onderstaande pagina's kom je alsnog waar je wilde zijn.
            </p>

            <ul className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-10" data-id="element-1901" data-mp="1o3of4ptpdr8j">
              {internalServices.map(service => <li key={service.title} data-id="element-1902" data-mp="1t1gj4i7mh3t3">
                  <Link to={service.link} className="group flex items-center justify-between gap-4 rounded-xl border border-gray-200 p-5 hover:border-[#004AC7] transition-colors duration-200" data-id="element-1903" data-mp="3pursvnyw3lxb">
                    <span className="font-semibold text-[#111827]" data-id="element-1904" data-mp="11yures0myuw5">
                      {service.title}
                    </span>
                    <ArrowRightIcon className="h-4 w-4 text-[#004AC7] flex-shrink-0 transform group-hover:translate-x-1 transition-transform duration-200" aria-hidden="true" data-id="element-1905" data-mp="x12z3ww2x6rf" />
                  </Link>
                </li>)}
            </ul>

            <div className="flex flex-col sm:flex-row gap-4" data-id="element-1906" data-mp="162u4f0mpjbkr">
              <Link to="/" className="inline-flex items-center justify-center bg-[#004AC7] hover:bg-[#003A9E] text-white font-semibold py-4 px-8 rounded-lg transition-colors duration-200 shadow-md" data-id="element-1907" data-mp="1kwypmrezj9j6">
                Naar de homepage
              </Link>
              <Link to="/sitemap" className="inline-flex items-center justify-center border border-gray-300 text-[#111827] font-semibold py-4 px-8 rounded-lg hover:border-[#004AC7] hover:text-[#004AC7] transition-colors duration-200" data-id="element-1908" data-mp="1pop33697ydet">
                Bekijk alle pagina's
              </Link>
            </div>
          </div>
        </section>
      </main>

      <Footer data-id="element-1909" data-mp="2ici1rgje12qm" />
    </div>;
};